module.exports = __webpack_public_path__ + "static/img/F1.b3573977.jpg";